<div
  class="
    d-flex
    justify-content-center
    align-items-center
    p-2
    mb-3
    bg-light
    border-bottom
    box-shadow
  "
>
  <div class="col-4 d-flex align-items-center">
    <i class="fa fa-pied-piper-pp me-1 mb-0 mt-0" id="logo-initials"></i>
    <h4 class="companyName">Piedmont Plastics</h4>
  </div>
  <nav class="col-4 text-center">
    <a class="p-2 text-dark" routerLink="/">Calculator</a>
    <i class="fa fa-pied-piper-alt ms-3 me-3 mb-0 mt-0" id="logo-graphic"></i>
    <a class="p-2 text-dark" routerLink="/CalculationsHistory">History</a>
  </nav>
  <div class="col-4 d-flex justify-content-end">
    <label for="userSelect"></label>
    <select
      class="form-select-sm ms-1 me-2"
      id="userSelect"
      (focus)="getUsers()"
      (change)="getNewUser($event.target.value)"
    >
      <option *ngFor="let user of users" value="{{ user.id }}">
        {{ user.username }}
      </option>
    </select>
    <div class="ms-1">
      <span (click)="openModal()" id="addUser"
        ><i class="fa fa-user-plus" id="addUserIcon"></i
      ></span>
    </div>
  </div>
</div>
